module.exports = __webpack_public_path__ + "static/img/product4.4e49161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/product4.png
// module id = njf4
// module chunks = 4